var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.block},[_c('div',{class:_vm._.list},_vm._l((_vm.data),function(item,index){return _c('img',{key:index,class:_vm._.img,attrs:{"src":item.icon},on:{"click":function($event){return _vm.handleClick(item)}}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }